export default function initializeMenu() {
    handleHover()

    window.addEventListener("resize", (e) => {
        if (window.innerWidth > 1023) {
            const menuOverlay = document.querySelector('div.menu-overlay')
            if (menuOverlay.classList.contains('active')) {
                menuOverlay.classList.remove('active')
            }

            // bit ugly but removes the js styles
            const menuli = [...document.querySelectorAll('li.menu-li.sub')]
            const submenus = [...document.querySelectorAll('div.menu-submenu')]

            menuli.forEach(li => {
                li.style.removeProperty('height');
            })
            submenus.forEach(submenu => {
                submenu.style.removeProperty('top');
                submenu.style.removeProperty('display');
            })
        }
    })
}

function handleHover() {
    const subItem = [...document.querySelectorAll('header li.menu-li')]
    const submenu = [...document.querySelectorAll('header .menu-submenu')]
    const hamburger = document.querySelector('.menu-hamburger')
    const mobile_close = document.querySelector('.mobile-close')

    subItem.forEach(item => {
        item.addEventListener('mouseenter', (e) => { 
            onMouseEnter(item, e)
        })
        item.addEventListener('mouseleave', (e) => {
            onMouseLeave(item)
        })
    })

    submenu.forEach(item => {
        item.addEventListener('mouseenter', (e) => {
            onMouseEnter(item, e)
        })
        item.addEventListener('mouseleave', (e) => { 
            onMouseLeave(item)
        })
    })

    hamburger.addEventListener('click', (e) => {
        onClick()
    })

    mobile_close.addEventListener('click', (e) => {
        onClick()
    })
}

function onMouseEnter(item, e) {
    if (window.innerWidth < 768) {
        e.preventDefault()

        mobileHandler(item)
    } else {
        let id = item.dataset.menuId
        if (item.classList.contains("menu-submenu")) {
            item.classList.add("hover")
            let el = document.querySelector(`.menu-li[data-menu-id='${id}']`)
            if (el) {
                el.classList.add("hover")
            }
        } else {
            item.classList.add("hover")
            let el = document.querySelector(`.menu-submenu[data-menu-id='${id}']`)
            if (el) {
                el.classList.add("hover")
            }
        }
    }
}

function mobileHandler(item) {
    const header = document.querySelector('header')

    let id = item.dataset.menuId
    if (!item.classList.contains('menu-submenu')) {
        if (!item.classList.contains('open')) {
            let bodyRect = header.getBoundingClientRect(), elemRect = item.getBoundingClientRect(), offset = elemRect.top - bodyRect.top;
            let el = document.querySelector(`.menu-submenu[data-menu-id='${id}']`)

            if (el) {
                el.style.top = (offset + 37) + 'px'
                el.style.display = 'block'
                item.classList.add('open')

                setTimeout(_ => {
                    el.classList.add('hover')
                }, 600)
                
                item.style.height = (el.offsetHeight + 47) + 'px'
            }
        } else {
            let el = document.querySelector(`.menu-submenu[data-menu-id='${id}']`)
            el.classList.remove('hover')
            setTimeout(_ => {
                item.classList.remove('open')
                el.style.removeProperty('display')
                el.style.removeProperty('top')
                item.style.height = '37px'
            }, 300)
        }
    }
}

function onMouseLeave(item) {
    if (window.innerWidth < 768) {

    } else {
        let id = item.dataset.menuId
        if (item.classList.contains("menu-submenu")) {
            item.classList.remove("hover")
            let el = document.querySelector(`.menu-li[data-menu-id='${id}']`)
            if (el) {
                el.classList.remove("hover")
            }
        } else {
            item.classList.remove("hover")
            let el = document.querySelector(`.menu-submenu[data-menu-id='${id}']`)
            if (el) {
                el.classList.remove("hover")
            }
        }
    }
}

function onClick() {
    const menuTree = document.querySelector('div.menu-tree')
    const menuOverlay = document.querySelector('div.menu-overlay')

    if (menuTree.classList.contains('open')) {
        menuTree.classList.remove('open')
        menuOverlay.classList.remove('active')

        const submenus = [...document.querySelectorAll('div.menu-submenu')]
        const openItems = [...document.querySelectorAll('li.menu-li.open')]
        submenus.forEach(submenu => {
            submenu.classList.remove('hover')
            submenu.style.removeProperty('display')
        })
        openItems.forEach(items => {
            items.style.height = 'auto'
            items.classList.remove('open')
        })
    } else { 
        menuTree.classList.add('open')
        menuOverlay.classList.add('active')
    }
}